(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6574],{

/***/ 86817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/[page]",
      function () {
        return __webpack_require__(77305);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_components_knowledge_library_KnowledgeLibrary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83685);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var types_enums__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41390);




var KnowledgeLibraryArticlesPage = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_knowledge_library_KnowledgeLibrary__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        currentSectionState: types_enums__WEBPACK_IMPORTED_MODULE_3__/* .KlList.STORIES */ .ij.STORIES,
        data: data
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (KnowledgeLibraryArticlesPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,7229,9000,9891,5611,1947,9774,2888,179], function() { return __webpack_exec__(86817); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);